import { parseRFC5646Tag } from './locale';

export function browserLanguage() {
  return parseRFC5646Tag(navigator.language);
}
